import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const AccordionGroup = React.forwardRef((props, ref) => {
  const {
    children,
    noBorders = false
  } = props;

  // eslint-disable-next-line max-len
  let controlledChildren = !Array.isArray(children) ? children : children.map((child, index) => React.cloneElement(child, { noBorders: child.props.noBorders || noBorders }));

  if (noBorders && Array.isArray(controlledChildren)) {
    controlledChildren = controlledChildren.map((child, index) => (
      <Fragment key={`accordion-fragment-${index}`}>
        { child }
        {
          (index < controlledChildren.length - 1) && (
            <div className="sui-h-0 sui-w-full sui-pt-2 sui-border-t sui-border-solid sui-border-t-1 sui-border-primary" />
          )
        }
      </Fragment>
    ));
  }

  return (
    <div
      ref={ref}
      className="sui-flex sui-flex-col sui-justify-start sui-items-center"
    >
      { controlledChildren }
    </div>
  );
});

AccordionGroup.displayName = 'AccordionGroup';

AccordionGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * If `true`, then the Accordion childs will be displayed without borders.
   * @default false
   */
  noBorders: PropTypes.bool
};

export { AccordionGroup };
